import { render, staticRenderFns } from "./StudentCalendar.vue?vue&type=template&id=35dba328&"
import script from "./StudentCalendar.vue?vue&type=script&lang=js&"
export * from "./StudentCalendar.vue?vue&type=script&lang=js&"
import style0 from "./StudentCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports